import React from 'react';
import { object, number, array, string } from 'prop-types';
import { animated } from '@react-spring/web';
import cx from 'classnames';
import LazyLoad from 'react-lazyload';
import useStyles from 'hooks/useStyles';
import { getElementVisibility } from 'components/Features/utils';
import LoadingSkeleton from 'components/LoadingSkeleton';
import styles from './AnimationElementDesktop.scss';

const TypesStyleMap = {
  1: {
    imageVertical: styles.typeOneImageLeft,
    imageHorizontal: styles.typeOneImageRight,
    info: styles.typeOneInfo,
  },
  2: {
    imageVertical: styles.typeTwoImageRight,
    imageHorizontal: styles.typeTwoImageLeft,
    info: styles.typeTwoInfo,
  },
  3: {
    imageVertical: styles.typeThreeImageLeft,
    imageHorizontal: styles.typeThreeImageRight,
    info: styles.typeThreeInfo,
  },
};

const AnimationElementDesktop = ({
  title,
  description,
  imageFull,
  imageHorizontal,
  imageVertical,
  groupStatus,
  firstGroupStyles,
  groupOneStyles,
  groupTwoStyles,
  type,
}) => {
  useStyles(styles);

  return (
    <LazyLoad
      height={400}
      offset={0}
      placeholder={<LoadingSkeleton className={styles.fullLoading} />}
    >
      <animated.img
        style={{
          ...(groupStatus[0] ? firstGroupStyles || groupOneStyles : null),
          visibility: getElementVisibility(groupStatus[0], imageFull),
        }}
        src={imageFull}
        // alt={title}
        alt={groupStatus[0]}
        className={styles.imageFull}
      />

      <animated.div
        style={{
          ...(groupStatus[1] ? groupTwoStyles : null),
          visibility: getElementVisibility(groupStatus[1], imageVertical),
        }}
        className={styles.groupTwo}
      >
        <img
          src={imageVertical}
          alt={title}
          className={cx(
            styles.imageVertical,
            TypesStyleMap[type].imageVertical,
          )}
        />
        <img
          src={imageHorizontal}
          alt={title}
          className={cx(
            styles.imageHorizontal,
            TypesStyleMap[type].imageHorizontal,
          )}
        />
        <div className={cx(styles.info, TypesStyleMap[type].info)}>
          <h3 className={styles.infoTitle}>{title}</h3>
          <div className={styles.infoText}>{description}</div>
        </div>
      </animated.div>
    </LazyLoad>
  );
};

AnimationElementDesktop.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  imageFull: string.isRequired,
  imageHorizontal: string.isRequired,
  imageVertical: string.isRequired,
  groupStatus: array.isRequired,
  groupOneStyles: object.isRequired,
  groupTwoStyles: object.isRequired,
  type: number.isRequired,
  firstGroupStyles: array,
};

AnimationElementDesktop.defaultProps = {
  firstGroupStyles: null,
};

export default AnimationElementDesktop;
